<template>
  <td>
    <template v-if="wick.url">
      <a :href="wick.url">
        {{ wick.name }}
      </a>
    </template>
    <template v-else>
      {{ wick.name }}
    </template>

    {{ wick.suffix }}
  </td>
</template>

<script>
  export default {
    props: {
      wick: { type: Object, required: true }
    }
  }
</script>
